// libs
import React, { memo, useMemo, useState } from 'react';
import { styled } from '@nykaa/ui-components';
import isEmpty from 'lodash/isEmpty';

// defs
import { ImageProps } from './types';

// constant
import { COLORS } from 'shared/styles/base';

// styles
const Image = styled.img<{ bckgrndClr: string }>`
  width: 100%;
  height: auto;
  background-color: ${(props) => props.bckgrndClr};
`;

// helpers
import { getSrcSet } from './helpers';

function ImageV2({
  src,
  width,
  height,
  aspectRatio,
  className = '',
  placeholderColor = COLORS.PLACEHOLDER,
  onLoadPlaceholderColor,
  alt = '',
  lazy = true,
  srcSet = '',
  onImageLoad,
  ...props
}: ImageProps) {
  const [backgroundColor, setBackgroundColor] = useState(placeholderColor);

  const handleImageLoad = () => {
    onImageLoad && onImageLoad();
    if (isEmpty(onLoadPlaceholderColor)) return;

    setBackgroundColor(onLoadPlaceholderColor);
  };

  let finalWidth = width;
  let finalHeight = height;

  if (aspectRatio && aspectRatio !== 0 && width) {
    finalWidth = width;
    finalHeight = width / aspectRatio;
  }

  if (aspectRatio && aspectRatio !== 0 && height) {
    finalHeight = height;
    finalWidth = height * aspectRatio;
  }

  if (width && height) {
    finalWidth = width;
    finalHeight = height;
  }

  const finalSrcSet = useMemo(() => {
    if (isEmpty(srcSet) && finalWidth !== undefined) {
      return getSrcSet(src, finalWidth);
    }
    return '';
  }, [finalWidth, src, srcSet]);

  return (
    <Image
      src={src}
      className={className}
      width={finalWidth}
      height={finalHeight}
      alt={alt}
      srcSet={finalSrcSet}
      //@ts-ignore
      loading={lazy ? 'lazy' : 'eager'}
      bckgrndClr={backgroundColor}
      onLoad={handleImageLoad}
      {...props}
    />
  );
}

export default memo(ImageV2);
